module.exports = __webpack_public_path__ + "img/icon-16-import.1d14e5bd.svg";